import {ArrayWithDefault, ComponentHelper, SteuernummerFormat, SteuernummerHelper, WizardPageBaseComponent} from '@utils-lib';
import {Component} from '@angular/core';
import {AppNameEnum, Finanzamt, FinanzamtAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-lib-finanzamt-angaben',
    templateUrl: './finanzamt-angaben.component.html'
})
export class FinanzamtAngabenComponent extends WizardPageBaseComponent<FinanzamtAngaben> {

    static nutzdatenPath = 'finanzamtAngaben';
    static route = 'finanzamt-angaben';

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public getSteuernummerMask(finanzamtnummer: string): SteuernummerFormat {
        return SteuernummerHelper.getMaskFormat(finanzamtnummer);
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {

        const finanzamt: ArrayWithDefault<Finanzamt> = {standardIndex: 0, array: []};

        if (this.stammdaten?.antragsteller?.finanzamt) {
            finanzamt.array.push(this.stammdaten.antragsteller.finanzamt);
        }
        if (this.stammdaten?.unternehmen?.finanzamt) {
            finanzamt.array.push(this.stammdaten.unternehmen.finanzamt);
        }
        if (finanzamt.array.length > 1) {
            const fragebogenType = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
            switch (fragebogenType) {
                case AppNameEnum.FragebogenEUn:
                case AppNameEnum.FragebogenBetPG:
                    finanzamt.standardIndex = 0;
                    break;
                case AppNameEnum.FragebogenKapG:
                case AppNameEnum.FragebogenPersG:
                case AppNameEnum.FragebogenKapGAus:
                    finanzamt.standardIndex = 1;
                    break;
                default:
                    finanzamt.standardIndex = 0;
                    break;
            }
        }

        return new Map<string, unknown | Array<unknown>>([
            ['finanzamt', finanzamt]
        ]);
    }
}
